import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _6003dd56 = () => interopDefault(import('../pages/a-good-company.vue' /* webpackChunkName: "pages/a-good-company" */))
const _2cb5cca1 = () => interopDefault(import('../pages/anker/index.vue' /* webpackChunkName: "pages/anker/index" */))
const _6cce92fa = () => interopDefault(import('../pages/anker-bundle-aktion.vue' /* webpackChunkName: "pages/anker-bundle-aktion" */))
const _6f46aaed = () => interopDefault(import('../pages/bitte-kommen-sie-spaeter-wieder.vue' /* webpackChunkName: "pages/bitte-kommen-sie-spaeter-wieder" */))
const _2b4d2939 = () => interopDefault(import('../pages/google/index.vue' /* webpackChunkName: "pages/google/index" */))
const _79d7e1b4 = () => interopDefault(import('../pages/handyrechnung-aktion.vue' /* webpackChunkName: "pages/handyrechnung-aktion" */))
const _5774b624 = () => interopDefault(import('../pages/handyvergleich.vue' /* webpackChunkName: "pages/handyvergleich" */))
const _9386fa9e = () => interopDefault(import('../pages/infos-zum-online-kauf.vue' /* webpackChunkName: "pages/infos-zum-online-kauf" */))
const _87d4311a = () => interopDefault(import('../pages/kontakt.vue' /* webpackChunkName: "pages/kontakt" */))
const _a0a95734 = () => interopDefault(import('../pages/maintenance.vue' /* webpackChunkName: "pages/maintenance" */))
const _2bf922e9 = () => interopDefault(import('../pages/merkliste.vue' /* webpackChunkName: "pages/merkliste" */))
const _45a46ea5 = () => interopDefault(import('../pages/panzerglass.vue' /* webpackChunkName: "pages/panzerglass" */))
const _a5adf21e = () => interopDefault(import('../pages/preisvorteile-sichern.vue' /* webpackChunkName: "pages/preisvorteile-sichern" */))
const _4c55c410 = () => interopDefault(import('../pages/samsung/index.vue' /* webpackChunkName: "pages/samsung/index" */))
const _d95c975e = () => interopDefault(import('../pages/samsung-cashback-aktion.vue' /* webpackChunkName: "pages/samsung-cashback-aktion" */))
const _89c947e0 = () => interopDefault(import('../pages/smart-home-entdecken.vue' /* webpackChunkName: "pages/smart-home-entdecken" */))
const _79cdf07e = () => interopDefault(import('../pages/soundcore.vue' /* webpackChunkName: "pages/soundcore" */))
const _0d595a8e = () => interopDefault(import('../pages/stabiles-internet.vue' /* webpackChunkName: "pages/stabiles-internet" */))
const _5211d87e = () => interopDefault(import('../pages/themenwelten.vue' /* webpackChunkName: "pages/themenwelten" */))
const _35130528 = () => interopDefault(import('../pages/urlaubsessentials.vue' /* webpackChunkName: "pages/urlaubsessentials" */))
const _1c9ae8b8 = () => interopDefault(import('../pages/xiaomi.vue' /* webpackChunkName: "pages/xiaomi" */))
const _1ae6248e = () => interopDefault(import('../pages/xiaomi-smartphones.vue' /* webpackChunkName: "pages/xiaomi-smartphones" */))
const _3c5ef9d7 = () => interopDefault(import('../pages/xiaomi-zubehoer.vue' /* webpackChunkName: "pages/xiaomi-zubehoer" */))
const _339725bb = () => interopDefault(import('../pages/zahlung-per-handyrechnung.vue' /* webpackChunkName: "pages/zahlung-per-handyrechnung" */))
const _25922d48 = () => interopDefault(import('../pages/anker/product-data.ts' /* webpackChunkName: "pages/anker/product-data" */))
const _f6e71a84 = () => interopDefault(import('../pages/google/product-data.js' /* webpackChunkName: "pages/google/product-data" */))
const _86959aac = () => interopDefault(import('../pages/hilfe/lieferstatus-und-retoure.vue' /* webpackChunkName: "pages/hilfe/lieferstatus-und-retoure" */))
const _4a18db60 = () => interopDefault(import('../pages/magenta-black-days/page-data.js' /* webpackChunkName: "pages/magenta-black-days/page-data" */))
const _a6d55cea = () => interopDefault(import('../pages/samsung/product-data.ts' /* webpackChunkName: "pages/samsung/product-data" */))
const _22f440b0 = () => interopDefault(import('../pages/shop/bestaetigung.vue' /* webpackChunkName: "pages/shop/bestaetigung" */))
const _02e9c8a1 = () => interopDefault(import('../pages/shop/brodos-zahlungsverifizierung.vue' /* webpackChunkName: "pages/shop/brodos-zahlungsverifizierung" */))
const _a7e06d08 = () => interopDefault(import('../pages/shop/fehler.vue' /* webpackChunkName: "pages/shop/fehler" */))
const _3427cd21 = () => interopDefault(import('../pages/shop/kundenformular.vue' /* webpackChunkName: "pages/shop/kundenformular" */))
const _7dd436e4 = () => interopDefault(import('../pages/shop/kundenformular/index.vue' /* webpackChunkName: "pages/shop/kundenformular/index" */))
const _6e9574b2 = () => interopDefault(import('../pages/shop/kundenformular/persoenliche-daten.vue' /* webpackChunkName: "pages/shop/kundenformular/persoenliche-daten" */))
const _962db776 = () => interopDefault(import('../pages/shop/kundenformular/zahlungsart.vue' /* webpackChunkName: "pages/shop/kundenformular/zahlungsart" */))
const _511d211e = () => interopDefault(import('../pages/shop/telekom-bestaetigung.vue' /* webpackChunkName: "pages/shop/telekom-bestaetigung" */))
const _bf3e7a56 = () => interopDefault(import('../pages/shop/telekom-bezahlung-information.vue' /* webpackChunkName: "pages/shop/telekom-bezahlung-information" */))
const _22cb288f = () => interopDefault(import('../pages/shop/telekom-zahlungsverifizierung.vue' /* webpackChunkName: "pages/shop/telekom-zahlungsverifizierung" */))
const _bc7fdb6e = () => interopDefault(import('../pages/shop/warenkorb.vue' /* webpackChunkName: "pages/shop/warenkorb" */))
const _ad2d2586 = () => interopDefault(import('../pages/shop/zahlungsverifizierung.vue' /* webpackChunkName: "pages/shop/zahlungsverifizierung" */))
const _bc58c4f6 = () => interopDefault(import('../pages/shop/zusammenfassung.vue' /* webpackChunkName: "pages/shop/zusammenfassung" */))
const _5347ef82 = () => interopDefault(import('../pages/weitere-informationen/agb-brodos.vue' /* webpackChunkName: "pages/weitere-informationen/agb-brodos" */))
const _bf1e7400 = () => interopDefault(import('../pages/weitere-informationen/sitemap.vue' /* webpackChunkName: "pages/weitere-informationen/sitemap" */))
const _2a6fa61c = () => interopDefault(import('../pages/weitere-informationen/ueber-brodos.vue' /* webpackChunkName: "pages/weitere-informationen/ueber-brodos" */))
const _453aefd8 = () => interopDefault(import('../pages/weitere-informationen/ueber-qivicon.vue' /* webpackChunkName: "pages/weitere-informationen/ueber-qivicon" */))
const _6a941ae5 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _8f901d14 = () => interopDefault(import('../pages/magenta-moments-2024/_slug.vue' /* webpackChunkName: "pages/magenta-moments-2024/_slug" */))
const _f4e4b032 = () => interopDefault(import('../special-pages/product-details.vue' /* webpackChunkName: "" */))
const _ffccdd50 = () => interopDefault(import('../special-pages/shop-list.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/a-good-company",
    component: _6003dd56,
    name: "a-good-company"
  }, {
    path: "/anker",
    component: _2cb5cca1,
    name: "anker"
  }, {
    path: "/anker-bundle-aktion",
    component: _6cce92fa,
    name: "anker-bundle-aktion"
  }, {
    path: "/bitte-kommen-sie-spaeter-wieder",
    component: _6f46aaed,
    name: "bitte-kommen-sie-spaeter-wieder"
  }, {
    path: "/google",
    component: _2b4d2939,
    name: "google"
  }, {
    path: "/handyrechnung-aktion",
    component: _79d7e1b4,
    name: "handyrechnung-aktion"
  }, {
    path: "/handyvergleich",
    component: _5774b624,
    name: "handyvergleich"
  }, {
    path: "/infos-zum-online-kauf",
    component: _9386fa9e,
    name: "infos-zum-online-kauf"
  }, {
    path: "/kontakt",
    component: _87d4311a,
    name: "kontakt"
  }, {
    path: "/maintenance",
    component: _a0a95734,
    name: "maintenance"
  }, {
    path: "/merkliste",
    component: _2bf922e9,
    name: "merkliste"
  }, {
    path: "/panzerglass",
    component: _45a46ea5,
    name: "panzerglass"
  }, {
    path: "/preisvorteile-sichern",
    component: _a5adf21e,
    name: "preisvorteile-sichern"
  }, {
    path: "/samsung",
    component: _4c55c410,
    name: "samsung"
  }, {
    path: "/samsung-cashback-aktion",
    component: _d95c975e,
    name: "samsung-cashback-aktion"
  }, {
    path: "/smart-home-entdecken",
    component: _89c947e0,
    name: "smart-home-entdecken"
  }, {
    path: "/soundcore",
    component: _79cdf07e,
    name: "soundcore"
  }, {
    path: "/stabiles-internet",
    component: _0d595a8e,
    name: "stabiles-internet"
  }, {
    path: "/themenwelten",
    component: _5211d87e,
    name: "themenwelten"
  }, {
    path: "/urlaubsessentials",
    component: _35130528,
    name: "urlaubsessentials"
  }, {
    path: "/xiaomi",
    component: _1c9ae8b8,
    name: "xiaomi"
  }, {
    path: "/xiaomi-smartphones",
    component: _1ae6248e,
    name: "xiaomi-smartphones"
  }, {
    path: "/xiaomi-zubehoer",
    component: _3c5ef9d7,
    name: "xiaomi-zubehoer"
  }, {
    path: "/zahlung-per-handyrechnung",
    component: _339725bb,
    name: "zahlung-per-handyrechnung"
  }, {
    path: "/anker/product-data",
    component: _25922d48,
    name: "anker-product-data"
  }, {
    path: "/google/product-data",
    component: _f6e71a84,
    name: "google-product-data"
  }, {
    path: "/hilfe/lieferstatus-und-retoure",
    component: _86959aac,
    name: "hilfe-lieferstatus-und-retoure"
  }, {
    path: "/magenta-black-days/page-data",
    component: _4a18db60,
    name: "magenta-black-days-page-data"
  }, {
    path: "/samsung/product-data",
    component: _a6d55cea,
    name: "samsung-product-data"
  }, {
    path: "/shop/bestaetigung",
    component: _22f440b0,
    name: "shop-bestaetigung"
  }, {
    path: "/shop/brodos-zahlungsverifizierung",
    component: _02e9c8a1,
    name: "shop-brodos-zahlungsverifizierung"
  }, {
    path: "/shop/fehler",
    component: _a7e06d08,
    name: "shop-fehler"
  }, {
    path: "/shop/kundenformular",
    component: _3427cd21,
    children: [{
      path: "",
      component: _7dd436e4,
      name: "shop-kundenformular"
    }, {
      path: "persoenliche-daten",
      component: _6e9574b2,
      name: "shop-kundenformular-persoenliche-daten"
    }, {
      path: "zahlungsart",
      component: _962db776,
      name: "shop-kundenformular-zahlungsart"
    }]
  }, {
    path: "/shop/telekom-bestaetigung",
    component: _511d211e,
    name: "shop-telekom-bestaetigung"
  }, {
    path: "/shop/telekom-bezahlung-information",
    component: _bf3e7a56,
    name: "shop-telekom-bezahlung-information"
  }, {
    path: "/shop/telekom-zahlungsverifizierung",
    component: _22cb288f,
    name: "shop-telekom-zahlungsverifizierung"
  }, {
    path: "/shop/warenkorb",
    component: _bc7fdb6e,
    name: "shop-warenkorb"
  }, {
    path: "/shop/zahlungsverifizierung",
    component: _ad2d2586,
    name: "shop-zahlungsverifizierung"
  }, {
    path: "/shop/zusammenfassung",
    component: _bc58c4f6,
    name: "shop-zusammenfassung"
  }, {
    path: "/weitere-informationen/agb-brodos",
    component: _5347ef82,
    name: "weitere-informationen-agb-brodos"
  }, {
    path: "/weitere-informationen/sitemap",
    component: _bf1e7400,
    name: "weitere-informationen-sitemap"
  }, {
    path: "/weitere-informationen/ueber-brodos",
    component: _2a6fa61c,
    name: "weitere-informationen-ueber-brodos"
  }, {
    path: "/weitere-informationen/ueber-qivicon",
    component: _453aefd8,
    name: "weitere-informationen-ueber-qivicon"
  }, {
    path: "/",
    component: _6a941ae5,
    name: "index"
  }, {
    path: "/magenta-moments-2024/:slug?",
    component: _8f901d14,
    name: "magenta-moments-2024-slug"
  }, {
    path: "/geraete/:slug?",
    component: _f4e4b032,
    name: "ProductDetails"
  }, {
    path: "/:config+",
    component: _ffccdd50,
    name: "ShopList"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
